import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
	NavigateSidebarEvent,
	NavigateSidebarSupportEvent,
	OpenSidebarEventTypes,
} from '../../types';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class NewRightSidebarService {
	private readonly router = inject(Router);
	isOpenState$ = new BehaviorSubject<boolean>(false);
	isSupportOpen$ = new BehaviorSubject<boolean>(false);
	gracefulClose$ = new Subject<void>();
	closeSupport$ = new Subject<void>();

	constructor() {}

	isOpen(): boolean {
		return this.isOpenState$.value;
	}

	isSupportOpen(): boolean {
		return this.isSupportOpen$.value;
	}

	navigate(event: NavigateSidebarEvent) {
		switch (event.type) {
			case OpenSidebarEventTypes.OpenAiChat:
				this.router.navigate([
					{ outlets: { 'right-sidebar': [event.route], support: null } },
				]);
				break;
			case OpenSidebarEventTypes.OpenWorkOrder:
				this.router.navigate([
					{ outlets: { 'right-sidebar': [event.route, event.pk], support: null } },
				]);
				break;
			case OpenSidebarEventTypes.OpenRoutineTemplate:
				this.router.navigate([
					{ outlets: { 'right-sidebar': [event.route, event.pk], support: null } },
				]);
				break;
		}
	}

	navigateAndOpenSupport(event: NavigateSidebarSupportEvent) {
		this.router.navigate([
			{
				outlets: {
					support: [event.entityType],
				},
			},
		]);

		if (this.isSupportOpen()) return;
		this.openSupport();
	}

	openAndNavigate(event: NavigateSidebarEvent) {
		this.navigate(event);
		if (this.isOpen()) return;
		this.open();
	}

	toggleAndNavigate(event: NavigateSidebarEvent) {
		if (!this.isOpen()) {
			this.navigate(event);
		}
		this.toggle();
	}

	toggle() {
		if (this.isOpen()) {
			this.close();
			return;
		}
		this.open();
	}

	open() {
		this.closeSupport();
		this.isOpenState$.next(true);
	}

	openSupport() {
		this.isSupportOpen$.next(true);
	}

	closeSupport() {
		this.closeSupport$.next();
		this.isSupportOpen$.next(false);
	}

	closeAndClearSupport() {
		this.closeSupport();
		this.router.navigate([{ outlets: { support: null } }]);
	}

	close() {
		this.gracefulClose$.next();
		this.closeAndClearSupport();
		this.clear();
	}

	clear() {
		this.router.navigate([{ outlets: { 'right-sidebar': null, support: null } }]);
	}
}
